// 部门管理
export default {
    departmentalInquiry: 'Departmental Inquiry',
    personInChargeInquiry: 'Person in charge inquiry',
    mobileNumberQuery: 'Mobile number query',
    department: 'Department',
    numberOfPeople: 'Number of People',
    principal: 'Principal',
    contactInformation: 'Contact information',
    countryOrRegion: 'country / region',
    provinceCity: 'Province/City',
    personnelManagement: 'Personnel management',
    addDepartment: 'Add department',
    editDepartment: 'Editorial department',
    departmentName: 'Department name',
    location: 'location',
    userAccount: 'user account',
    role: 'role',
    licenseType: 'License Type',
    departmentDescription: 'Department Description',
    pleaseEnterContent: 'Please enter content',
    nameQuery: 'name query',
    license: 'license',
    totalStaff: 'Total staff',
    personsName: "Person's name",
    telephone: 'telephone',
    operate: 'operate',
    enterDepartmentName: 'Please enter department name',
    PleaseSelectLocation: 'Please select a location',
    enterPerson: 'Please enter the person in charge',
    peopleSearch: 'people search',
    userExistsTip:"User already exists, please do not add it again",
    addFailedTip:"Add failed, the user is already in another department",
    selectAddper:'Please select the person you want to add',
    delTip:'Notice! After the department is deleted, the department personnel information will be retained, and the department data will be deleted, please operate with caution',
    delDep:'delete department'
}
